"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneType = void 0;
const react_1 = __importDefault(require("react"));
const simple_select_input_1 = __importDefault(require("../simple-select-input"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("./styles");
const PhoneType = ({ path }) => {
    const [state] = (0, use_form_1.default)(path);
    const { config: { isVisible = false } = {} } = state;
    if (isVisible === false)
        return null;
    return (react_1.default.createElement(styles_1.PhoneFieldStyles, { flexGrow: 2 },
        react_1.default.createElement(simple_select_input_1.default, { path: path, "data-testid": path })));
};
exports.PhoneType = PhoneType;
//# sourceMappingURL=phone-type.js.map